// extracted by mini-css-extract-plugin
export default {"wrapper":"HomeLocationSec_wrapper__5DgE6","locationBody":"HomeLocationSec_locationBody__ddSK5"};